import { render, staticRenderFns } from "./new_patient.vue?vue&type=template&id=6a466966&scoped=true"
import script from "./new_patient.vue?vue&type=script&lang=js"
export * from "./new_patient.vue?vue&type=script&lang=js"
import style0 from "./new_patient.vue?vue&type=style&index=0&id=6a466966&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a466966",
  null
  
)

export default component.exports